<template>
	<div class="chapter">
		<div class="num" contenteditable="true"></div>
		<div class="title"> <span contenteditable="true"></span></div>
	</div>
</template>

<script>
	export default {
		props: {
			value: {
				type: String
			}
		}
	}
</script>

<style>
</style>
